export default "__VITE_ASSET__DgJJhBFN__"